<div
  #viewport
  appGlossScroll
  appGlossScrollTrackOverflow
  class="tw-relative tw-overflow-y-auto tw-overscroll-contain"
  [attr.tabindex]="scrollbar.overflowing() ? 0 : null"
  [attr.role]="label() ? 'region' : null"
  [attr.aria-label]="label()"
>
  <div>
    <ng-content></ng-content>
  </div>
</div>
